import React from 'react';
import './it-infrastructure.css';
import { Helmet } from 'react-helmet';
import Banner from '../components/banner';
import Footer from '../components/footer';
import ServiceComponent from '../components/servicecomponent';
import LetsCode from '../components/letscode';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Link } from 'react-router-dom';

const implementation = `/images/it-infrastructure/implementation.png`;
const performance = `/images/it-infrastructure/performance.png`;
const storage = `/images/it-infrastructure/storage-disaster-recovery.png`;
const cloudSupport = `/images/it-infrastructure/cloud-support-services.png`;
const serverSupport = `/images/it-infrastructure/server-support-services.png`;
const networkSupport = `/images/it-infrastructure/network-support-services.png`;

const fileSystems = `/images/it-infrastructure/file-systems-and-directories.png`;
const operatingSystems = `/images/it-infrastructure/operating-systems-and-software.png`;
const firewallSolutions = `/images/it-infrastructure/firewall-solutions.png`;

const application = `/images/it-infrastructure/application-infrastructure-support.png`;
const website = `/images/it-infrastructure/website-support.png`;
const enterprise = `/images/it-infrastructure/enterprise-infrastructure-support.png`;
const smb = `/images/it-infrastructure/smb-it-support.png`;

const industry15 = `/images/icons/15-years-in-industry.png`;
const sourceCode = `/images/icons/source-code-delivery-to-clients.png`;
const microsoftAzure = `/images/icons/microsoft-365-azure.png`;
const response24 = `/images/icons/less-than-24-hrs-guaranteed-response.png`;
const certifiedDevelopers = `/images/icons/certified-developers.png`;
const projectManager = `/images/icons/dedicated-project-manager.png`;
const clients = `/images/icons/clients-usa-uk-australia.png`;
const tightDeadlines = `/images/icons/handle-tight-deadlines.png`;

const appMobile = `/images/app-mobile.png`;

const client = [
  `/images/clients/66deg-client.png`,
  `/images/clients/cabi.png`,
  `/images/clients/pro-it.png`,
  `/images/clients/scadea-client.png`,
  `/images/clients/techolution-client.png`,
  `/images/clients/next-loop.png`
];

const bannerDetails =
{
    title: 'Our Services',
    subTitle: 'IT INFRASTRUCTURE SUPPORT SERVICES'
}

const Support = [
  {
    image: implementation,
    heading: 'Design & Implementation',
    para: 'Our database architects possess deep expertise in aligning business needs with infrastructure management. They implement best practices and standards to optimize data flows and ensure system efficiency.',
  },
  {
    image: performance,
    heading: 'Performance Optimization',
    para: 'We conduct in-depth database performance analysis to identify bottlenecks, optimize SQL queries, and implement prioritized solutions for tangible improvements.',
  },
  {
    image: storage,
    heading: 'Storage Disaster Recovery',
    para: 'Our team deploys robust data backup and disaster recovery solutions, offering scalable and reliable safeguards to protect your critical systems and ensure continuity.',
  },
  {
    image: cloudSupport,
    heading: 'Cloud Support Services',
    para: 'We secure, manage, and optimize your cloud infrastructures to enhance business alignment, improve operational efficiency, and refine processes.',
  },
  {
    image: serverSupport,
    heading: 'Server Support Services',
    para: "Our server specialists handle installations, configurations, upgrades, and other management tasks, enhancing your servers' performance, reliability, and uptime.",
  },
  {
    image: networkSupport,
    heading: 'Network Support Services',
    para: 'We provide comprehensive network design and architectural planning, perform audits, and deliver ongoing support for TCP/IP setups, VPSs, SANs, LAN/WAN integrations, and network device troubleshooting to maintain optimal connectivity and performance.',
  },
]

const ItOperations = [
  {
    image: fileSystems,
    heading: 'File Systems & Directories',
    para: 'We safeguard your data with encryption, maintain PCI-DSS compliance, monitor file integrity, and conduct thorough server scans to detect viruses, backdoors, rootkits, and local exploits.',
  },
  {
    image: operatingSystems,
    heading: 'Operating Systems & Software',
    para: 'Our team ensures your operating systems, third-party integrations, and software are consistently updated and maintained to prevent vulnerabilities caused by outdated systems.',
  },
  {
    image: firewallSolutions,
    heading: 'Firewall, IDS, & IPS Solutions',
    para: "We protect your infrastructure with advanced software and hardware firewalls, network-based Intrusion Detection Systems (IDS), and Intrusion Prevention Systems (IPS). Regular audits and vulnerability scans further enhance your system's security.",
  }
]

const ItInfra = [
  {
    image: fileSystems,
    heading: 'Application Infrastructure Support',
    para: 'We safeguard your data with encryption, maintain PCI-DSS compliance, monitor file integrity, and conduct thorough server scans to detect viruses, backdoors, rootkits, and local exploits.',
  },
  {
    image: operatingSystems,
    heading: 'Website & E-Commerce IT Support',
    para: 'Our team ensures your operating systems, third-party integrations, and software are consistently updated and maintained to prevent vulnerabilities caused by outdated systems.',
  },
  {
    image: firewallSolutions,
    heading: 'Enterprise Infrastructure Support',
    para: "We design custom enterprise IT infrastructure solutions to streamline user management, access controls, security protocols, email and VoIP systems, large-scale data migrations, and more.",
  },
  {
    image: firewallSolutions,
    heading: 'SMB IT Support',
    para: "Our tailored IT infrastructure services for small to midsize businesses enhance communication and collaboration through efficient data sharing, document management, and video conferencing capabilities.",
  }
]

function ItInfrastructure() {
  return (
    <>

<Helmet>
   <meta name="description" content="Stamens Software, a leading IT company in Noida, offers robust IT infrastructure services in Noida India to ensure seamless performance, security, and scalability for your business."/>
   <meta name="keywords" content="IT Infrastructure Services, IT Infrastructure Services in Noida"/>
   <title>IT Infrastructure Services in Noida India by Stamens Software</title>
</Helmet>

<Banner details={bannerDetails} descriptionClass={'banner-head text-center'}/>

<section className="our-fetaures-itinfrastructure">
            <div className="container">
                <h2 className="head">Premier IT Infrastructure Support Services</h2>
                <p className="tagline">Stamens delivers expert outsourced IT infrastructure support, modernizing platforms and technologies to enhance agility and scalability. Our top-tier infrastructure management services ensure your systems operate efficiently and stay future-ready.</p>
                <div className="row gy-4">
                {Support.map((card, index) => (
               <ServiceComponent  key={index} serviceprops={card} parentClass={'col-md-6'} childClassA={'small-head'} />
            ))}  
                </div>
            </div>
        </section>

        <section className="work-process-itinfrastructure">
            <div className="container">
                <h3 className="head text-center">Enhance and Secure Your IT Operations with Stamens</h3>
                <p className="tagline text-center">Stamens transforms and safeguards your IT operations by implementing cutting-edge technologies, ensuring your business systems remain modern, secure, and efficient.</p>
                <div className="row gy-4">
                {ItOperations.map((card, index) => (
               <ServiceComponent  key={index} serviceprops={card} parentClass={'col-md-4'} childClassA={'small-head'} />
            ))}  
                </div>
            </div>
        </section>

      <LetsCode />

      <section className="application-solutions-itinfrastructure">
            <div className="container">
                <h3 className="head">IT Infrastructure Integration Support Services</h3>
                <p className="tagline">We provide seamless integration support for IT infrastructure, ensuring efficient connectivity between systems, optimized workflows, and enhanced operational performance.</p>
                <div className="row gy-4">
                {ItInfra.map((card, index) => (
               <ServiceComponent  key={index} serviceprops={card} parentClass={'col-md-6'} childClassA={'small-head'} />
            ))}  
                </div>
            </div>
        </section>

        <section className="our-company-itinfrastructure">
            <div className="container">
                <h4 className="head">
                    <span>Why Stamens Software</span>
                    We are one of the best IT companies?
                </h4>
                <div className="row gy-4">
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={industry15} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>15+ Years in Industry</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={sourceCode} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Source Code Delivery to Clients</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={microsoftAzure} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Microsoft 365, Azure</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={response24} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Less than 24 hrs Guaranteed Response</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={certifiedDevelopers} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Certified Developers</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={projectManager} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Dedicated Project Manager</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={clients} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Clients: USA, UK, Australia, etc.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={tightDeadlines} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Handle Tight Deadlines</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>   

        <section className="app-mobile-itinfrastructure">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-md-4">
                        <img src={appMobile} alt="app-mobile" className="img-fluid" />
                    </div>
                    <div className="col-md-8">
                        <h3 className="head"> Partner with our client-centered team for top-quality software solutions </h3>
                        <p>Our team of skilled developers have years of experience in developing mobile apps for a range of platforms, including iOS, Android, and Windows. We use the latest tools and technologies to ensure that our apps are optimized for performance, security, and usability.</p>
                        <p>We create seamless and intuitive iOS applications that deliver top-notch user experiences for iPhones and iPads. Our Android apps are designed to perform exceptionally across a wide range of devices with an optimized user experience.</p>
                        <p>Using frameworks like Flutter and React Native, we build apps that work efficiently across both iOS and Android platforms. Our design team creates visually stunning, user-centered interfaces that engage users and enhance app usability.</p>  
                        <Link to="/contact" className="hire-btn">Hire Us Now</Link>          
                    </div>
                </div>
            </div>
        </section>

        <section className="trusted-datamigration">
            <div className="container">
                <div className="text-center">
                    <h4 className="head"><span>Trusted Companies</span> Trusted by many companies</h4>
                    <p className="tagline col-md-9 mx-auto text-center fs-5 mb-5 d-block">Our commitment to quality and performance has earned us the trust of top brands, empowering them to deliver exceptional user experiences and achieve their business goals. Join a network of successful companies that leverage our technology to enhance their app development processes.</p>
                </div>
                <Swiper
            modules={[Autoplay, Pagination]}
              className="mySwiper3"
              spaceBetween={30}
              slidesPerView={5}
              autoplay={{
                delay: 1000,
                disableOnInteraction: true,
              }}
            >
              {client.map((client, index) => (
                <SwiperSlide key={index} className='swiper-slide'>
                  <img src={client} alt={`Client ${index + 1}`} className="img-fluid" height="103" width="237" />
                </SwiperSlide>
              ))}
            </Swiper>
            </div>
        </section>  

<Footer />
    </>
  )
}

export default ItInfrastructure;
